import { memo, useCallback, useMemo } from "react";

import type { PlanStock_StockManagementQuery } from "@/lib/gql/__generated__/graphql";

import { BlankContentForList } from "@/components/features/_components";
import { StockDailyItemMobile } from "@/components/features/items/stock/_shared/components/mobile/daily-item";

import { usePlanStockTablePresenter } from "./hooks/use-plan-table-presenter";

import type { PlanStockDiffStore } from "../../../../../model/usecase/use-create-form-model/plan-stock-diff-store";

type Props = {
	serverModel: PlanStock_StockManagementQuery;
	planStockDiffStore: PlanStockDiffStore;

	selectedItemIDs: string[];
};

export const PlanStockTableForMobile = memo(({ serverModel, planStockDiffStore, selectedItemIDs }: Props) => {
	const { filteredViewModel } = usePlanStockTablePresenter({
		serverModel,
		planStockDiffStore,
		selectedItemIDs,
	});

	const { items } = filteredViewModel;

	/**
	 * 在庫一覧を表示するか
	 */
	const canShowStockList = useMemo(() => items.length > 0, [items.length]);

	const handleSetStock = useCallback(
		(planID: string, date: string) => (isAvailable: boolean, remainNum: number) => {
			planStockDiffStore.put({ planID, date, isAvailable, remainNum });
		},
		[planStockDiffStore],
	);
	return (
		<div>
			{canShowStockList ? (
				<div>
					{items.map((item) => {
						const key = item.planID;

						return (
							<div key={key} className="space-y-4">
								{item.stocks.map((stock, idx) => {
									return (
										<StockDailyItemMobile
											key={`${key}-${stock.date}-${idx}`}
											stockDailyItem={stock}
											onSetStock={handleSetStock(key, stock.date)}
										/>
									);
								})}
							</div>
						);
					})}
				</div>
			) : (
				<BlankContentForList content="表示するプランがありません。" />
			)}
		</div>
	);
});

PlanStockTableForMobile.displayName = "PlanStockTableForMobile";
